/**
 * O PDF sem tipo respondido como "É outra CCB" (F-E144.F4-02): vira linha da conferência e destino
 * dos outros apoios antes de concluir, com a chave que o servidor dá ao contrato declarado
 * (`doc:<arquivo>`, ADR-0098 §2.2). A resposta que apontava um declarado que deixou de ser CCB sai.
 */
import {
  RESPOSTA_OUTRO_CONTRATO,
  type ContratoDoEnvioData,
  type EnvioDaAberturaData,
} from '@/lib/abertura_do_caso';

export function chaveDoDeclarado(documentoId: string): string {
  return `doc:${documentoId}`;
}

function declarados(envio: EnvioDaAberturaData, respostas: Readonly<Record<string, string>>) {
  return envio.perguntas.filter(
    (p) => p.pode_ser_contrato && respostas[p.unidade.documento_id] === RESPOSTA_OUTRO_CONTRATO,
  );
}

/** Os contratos do envio mais os declarados, cada um com os apoios que o citam. */
export function comOsDeclarados(
  envio: EnvioDaAberturaData,
  respostas: Readonly<Record<string, string>>,
): ContratoDoEnvioData[] {
  const novos = declarados(envio, respostas).map(({ unidade }): ContratoDoEnvioData => {
    const chave = chaveDoDeclarado(unidade.documento_id);
    return {
      chave,
      nome: unidade.nome,
      identificador: null,
      contratos: [],
      unidades: [unidade],
      apoios: envio.perguntas
        .filter((p) => respostas[p.unidade.documento_id] === chave)
        .map((p) => p.unidade),
      identificado: true,
      separacao_reprovada: false,
      situacao: 'novo',
      caso: null,
    };
  });
  return [...envio.contratos, ...novos];
}

/** As respostas sem a que aponta um arquivo que não está mais declarado como CCB. */
export function semDestinoSolto(
  envio: EnvioDaAberturaData,
  respostas: Readonly<Record<string, string>>,
): Record<string, string> {
  const vivos = new Set(
    declarados(envio, respostas).map((p) => chaveDoDeclarado(p.unidade.documento_id)),
  );
  const dePergunta = new Set(envio.perguntas.map((p) => chaveDoDeclarado(p.unidade.documento_id)));
  return Object.fromEntries(
    Object.entries(respostas).filter(
      ([, resposta]) => !dePergunta.has(resposta) || vivos.has(resposta),
    ),
  );
}
